<template>
  <v-text-field
    :value="value"
    v-bind="$attrs"
    :type="type"
    :append-icon="icon"
    v-on="$listeners"
    @click:append="showPassword = !showPassword"
  />
</template>
<script>
export default {
  props: {
    value: String,
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    icon() {
      return this.showPassword ? 'mdi-eye-off' : 'mdi-eye';
    },
    type() {
        return this.showPassword ? 'text' : 'password';
    }
  },
};
</script>
